import { render } from "./Home2022.vue?vue&type=template&id=72e99a76"
import script from "./Home2022.js?vue&type=script&lang=js"
export * from "./Home2022.js?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__